import React from 'react';
import DashboardRoutes from './dashboardRoutes.js';
import OrganisationRoutes from './organisationRoutes.js';
import PaymentsRoutes from './paymentRoutes';
import { SettingExamRoutes, SettingMessageTemplateRoutes, SettingOrderRoutes, SettingPatientRoutes, SettingContactRoutes, SettingCalendarRoutes, SettingInsuranceRoutes } from '../../itrust_common/routes/authorised/setting/index';
import { AppSettingCustomizeBackgroundRoutes } from './appSetting/index';
import ActivityRoutes from '../../itrust_common/routes/authorised/activityRoutes.js';
import Header from '../../itrust_common/components/authorised/layouts/Topbar.js';
import Sidebar from '../../components/authorised/layouts/Sidebar.js';
import ManageCountriesRoutes from './manageCountriesRoutes.js';

const headerMenu = [];
export default function AuthorizedRoutes(props) {
  const { handleLogout } = props

  return (
    <div>
      <Header headerMenu={headerMenu} handleLogout={handleLogout} />
      <div className="main-div">
        <Sidebar />
        <div className="main-content position-relative px-5 bg-light">
          {DashboardRoutes}
          {OrganisationRoutes}
          {ActivityRoutes}
          {PaymentsRoutes}
          {SettingExamRoutes}
          {SettingMessageTemplateRoutes}
          {SettingOrderRoutes}
          {SettingPatientRoutes}
          {SettingContactRoutes}
          {SettingCalendarRoutes}
          {SettingInsuranceRoutes}
          {AppSettingCustomizeBackgroundRoutes}
          {ManageCountriesRoutes}
        </div>
      </div>
    </div>
  )
}
